import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { Star } from 'lucide-react';

export default function Marketplace() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/marketplace').then(r => setItems(r.data || [])); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Authority Marketplace™</div>
        <h1 className="mt-2 font-display text-3xl tracking-tight">Trusted providers</h1>
        <p className="mt-2 text-sm text-muted-foreground">Vetted partners across PR, schema, podcast booking, writing, and AI consulting.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(p => (
          <div key={p.id} className="card-hover rounded-xl border border-border bg-card p-6">
            <div className="flex items-center justify-between">
              <Badge variant="outline" className="text-xs">{p.category}</Badge>
              <div className="flex items-center gap-1 text-xs"><Star className="h-3 w-3 fill-current text-primary" /> {p.rating}</div>
            </div>
            <div className="mt-4 font-display text-lg">{p.name}</div>
            <div className="mt-1 text-sm italic text-muted-foreground">{p.tagline}</div>
            <div className="mt-4 text-sm">{p.specialty}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
